import { cn } from "@/lib/utils";

export default function RenwuLogo({ className }: { className?: string }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      enableBackground="new 0 0 1024 1024"
      xmlSpace="preserve"
      className={cn("dark:invert", className)}
    >
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M538.575562,367.645782 
  C530.285767,373.268982 522.149414,378.490845 514.338867,384.161591 
  C507.829987,388.887207 506.532990,396.640411 510.248810,404.852478 
  C514.067810,413.292542 520.046936,416.619568 528.467102,414.910217 
  C561.027649,408.300293 589.949097,393.420715 617.125732,375.007385 
  C656.082642,348.612427 688.518005,315.668915 713.724365,275.834656 
  C721.300964,263.861023 727.617188,251.172775 732.963318,238.023849 
  C733.561279,236.553040 733.797607,234.707901 735.798218,234.194748 
  C737.757874,234.882355 737.346619,236.631195 737.279419,237.982925 
  C735.704895,269.661194 735.851074,301.555695 727.336121,332.467804 
  C711.876831,388.589752 678.891663,431.080475 627.819275,459.325775 
  C617.606445,464.973877 607.080750,469.954346 596.210205,474.202148 
  C594.353027,474.927887 592.430603,475.533325 591.120728,477.567230 
  C592.190918,480.786102 595.011169,482.732819 597.314941,485.007965 
  C624.744690,512.096680 654.703552,536.252502 684.818970,560.217163 
  C700.719543,572.870239 716.775513,585.327759 732.694214,597.958191 
  C734.411377,599.320618 736.786255,600.330627 737.092651,603.103455 
  C735.723206,604.903320 733.727234,605.261108 731.772827,605.264099 
  C712.443115,605.293701 693.052307,606.210388 673.798279,604.989929 
  C647.454346,603.320068 623.215820,594.070679 600.671692,580.454346 
  C556.558533,553.810547 520.779846,518.006836 488.711823,478.187500 
  C476.160858,462.602753 464.572662,446.319550 454.874634,428.763672 
  C450.097839,420.116516 446.271515,411.083923 444.719574,401.274017 
  C442.327362,386.152191 447.574219,373.370667 457.647675,362.458344 
  C466.228027,353.163452 475.506897,344.522034 482.659698,333.957306 
  C492.649384,319.202484 499.221252,303.122070 500.486877,285.320251 
  C501.681030,268.523651 495.447601,254.032272 484.522705,241.464890 
  C474.873169,230.364578 463.219696,221.334579 452.840881,210.983719 
  C451.572174,209.718369 449.951111,208.806305 448.843689,207.989075 
  C450.364532,204.415771 452.498077,204.692551 454.432281,204.691025 
  C478.095673,204.672394 501.799530,203.830673 525.409668,204.952942 
  C544.146912,205.843567 559.100525,215.896393 570.761658,230.292618 
  C597.328369,263.090302 595.160950,312.203827 566.044373,344.002197 
  C557.908447,352.887482 548.896057,360.748962 538.575562,367.645782 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M411.317993,410.000122 
  C411.324127,472.643951 411.330475,534.787781 411.335297,596.931641 
  C411.335938,605.134521 411.171295,605.315002 402.909637,605.320435 
  C380.751099,605.335083 358.592590,605.330078 336.434052,605.334351 
  C327.656372,605.335999 327.652039,605.337891 327.651947,596.765198 
  C327.650726,479.474884 327.618378,362.184540 327.760284,244.894394 
  C327.766449,239.793564 326.285156,236.180161 322.740234,232.615631 
  C315.462402,225.297607 308.613434,217.551651 301.635803,209.938004 
  C300.558075,208.762024 299.026733,207.783905 299.091766,205.722885 
  C300.834137,203.947968 303.122894,204.719284 305.149231,204.713608 
  C328.973633,204.646790 352.812561,205.170731 376.618195,204.497086 
  C394.635315,203.987259 411.373993,220.161011 411.349854,239.563553 
  C411.279358,296.208984 411.320374,352.854584 411.317993,410.000122 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M619.526489,803.230713 
  C613.576294,803.269104 608.067200,803.079529 602.581299,803.354004 
  C598.684509,803.548889 596.971008,801.904724 595.948303,798.287537 
  C587.624634,768.848450 579.171143,739.445923 570.733459,710.039124 
  C568.348328,701.726685 565.997864,693.401184 563.408264,685.151794 
  C562.177368,681.230957 563.040405,679.495239 567.355774,679.652954 
  C572.015625,679.823364 576.727661,680.078308 581.341858,679.588623 
  C586.718689,679.017883 588.963379,681.154358 590.288940,686.250488 
  C596.438538,709.893616 602.931030,733.447693 609.309570,757.031189 
  C609.688843,758.433350 610.145569,759.814514 610.865356,762.194702 
  C614.622192,749.378052 618.111450,737.475403 621.599976,725.572693 
  C625.622314,711.848389 629.739990,698.150818 633.599670,684.380920 
  C634.583435,680.871277 636.314941,679.455811 639.941833,679.627625 
  C644.763916,679.856140 649.621643,679.941040 654.432251,679.616028 
  C658.514526,679.340210 660.317261,680.927917 661.437866,684.803589 
  C668.271729,708.438171 675.326172,732.008911 682.318909,755.597473 
  C682.876648,757.478760 683.524414,759.333435 684.418030,762.086975 
  C690.983215,737.767090 697.199951,714.339355 703.655151,690.977478 
  C707.407288,677.397827 704.630005,679.980896 718.308289,679.698242 
  C721.473206,679.632874 724.653259,679.871643 727.803833,679.650085 
  C732.235352,679.338440 733.397339,680.893921 732.104065,685.212402 
  C726.809387,702.892761 721.706482,720.630798 716.566711,738.357361 
  C710.826233,758.155640 705.036438,777.940430 699.474854,797.789001 
  C698.355042,801.785461 696.621582,803.698853 692.229004,803.376099 
  C687.256104,803.010742 682.231812,803.151367 677.238586,803.325012 
  C673.841919,803.443176 672.241089,802.115234 671.268372,798.792358 
  C664.447510,775.490662 657.462524,752.236572 650.422424,728.999939 
  C649.737000,726.737732 649.626953,724.073120 646.849792,721.919678 
  C643.943970,731.445862 641.130005,740.600952 638.359558,749.769165 
  C633.453247,766.005615 628.580078,782.252136 623.673767,798.488647 
  C623.060730,800.517395 622.803894,802.883118 619.526489,803.230713 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M473.793762,701.257812 
  C487.115082,721.233826 500.238739,740.906921 513.907837,761.397766 
  C513.907837,740.122009 513.907349,719.799988 513.908203,699.477905 
  C513.908447,694.478455 513.937195,689.478821 513.907471,684.479553 
  C513.888306,681.249512 515.143677,679.546082 518.665405,679.660034 
  C523.659668,679.821655 528.670837,679.869263 533.660156,679.643738 
  C537.511536,679.469666 538.461487,681.217346 538.442688,684.730896 
  C538.344666,703.061890 538.424194,721.393677 538.424438,739.725220 
  C538.424744,758.556946 538.408325,777.388733 538.392334,796.220459 
  C538.386353,803.260071 538.269592,802.503235 531.594788,803.455322 
  C519.164490,805.228455 511.766052,800.491821 505.163574,789.729370 
  C492.548126,769.165222 478.179688,749.675232 464.479309,729.780334 
  C463.293793,728.058838 462.447571,725.930298 460.193573,724.974670 
  C458.793976,726.968750 459.377960,729.188477 459.373260,731.257263 
  C459.323517,753.088684 459.354919,774.920227 459.340057,796.751770 
  C459.335754,803.046814 459.118988,803.250732 452.916595,803.291565 
  C448.583832,803.320129 444.243774,803.134338 439.919800,803.329346 
  C436.124817,803.500549 434.593018,802.184998 434.604553,798.179932 
  C434.713593,760.350037 434.698334,722.519714 434.627380,684.689636 
  C434.620636,681.093079 435.848907,679.460632 439.566803,679.655823 
  C443.056824,679.839111 446.624298,680.105591 450.051300,679.605835 
  C457.125336,678.574280 461.657013,681.262878 464.902222,687.544556 
  C467.335571,692.254700 470.665375,696.501770 473.793762,701.257812 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M287.812805,803.301147 
  C282.672638,803.298584 277.992828,803.070801 273.345276,803.360840 
  C269.491699,803.601318 267.231628,801.981934 265.245880,798.852295 
  C257.928772,787.320129 250.308578,775.979858 243.028885,764.424683 
  C241.028442,761.249390 238.777618,759.620239 234.958755,759.912170 
  C231.645218,760.165466 228.294098,760.062195 224.965530,759.946167 
  C221.580002,759.828186 220.250229,761.199646 220.297440,764.683655 
  C220.446381,775.679626 220.166824,786.683105 220.420944,797.675232 
  C220.524078,802.136841 218.904343,803.619934 214.606277,803.355164 
  C210.123795,803.079163 205.596909,803.056519 201.116318,803.343323 
  C196.251312,803.654663 194.726257,801.581055 194.747314,796.898621 
  C194.876923,768.070984 194.810760,739.242371 194.810608,710.414124 
  C194.810562,701.915649 194.874756,693.416626 194.786758,684.919067 
  C194.747711,681.149536 196.230286,679.604553 200.150513,679.641785 
  C216.646240,679.798584 233.157013,679.327820 249.637421,679.858704 
  C264.736511,680.345093 278.259766,684.934387 286.516052,698.933105 
  C297.512848,717.578552 292.847839,746.013794 270.426361,754.955139 
  C269.525391,755.314331 268.741364,755.966919 267.731903,756.587952 
  C268.356873,760.111816 270.841827,762.506042 272.563629,765.226746 
  C279.065460,775.500671 285.813965,785.618225 292.386597,795.847961 
  C293.510162,797.596680 295.699554,799.389526 294.637939,801.596924 
  C293.412140,804.145691 290.523163,803.072021 287.812805,803.301147 
  M242.417664,736.677612 
  C244.744278,736.651978 247.085129,736.783264 249.395050,736.573669 
  C259.765625,735.632690 266.196686,729.869690 266.636902,721.253662 
  C267.124420,711.711365 262.432495,705.515991 251.930038,703.835999 
  C242.420288,702.314758 232.697647,703.283997 223.067886,703.349060 
  C220.530090,703.366211 220.347916,705.272888 220.351257,707.233398 
  C220.365662,715.710205 220.437393,724.188232 220.315155,732.663269 
  C220.270844,735.735107 221.562927,736.776917 224.485809,736.718079 
  C230.134766,736.604309 235.787537,736.680359 242.417664,736.677612 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M390.990112,679.690063 
  C392.653839,679.690430 393.820343,679.672974 394.986023,679.696106 
  C406.290039,679.920654 406.168030,677.603333 406.122101,691.183899 
  C406.077271,704.442566 407.305969,703.228821 393.999176,703.234436 
  C380.005951,703.240417 366.010956,703.375427 352.020538,703.181396 
  C347.605377,703.120117 346.091492,704.734802 346.322479,709.041992 
  C346.598633,714.191345 346.574158,719.375854 346.326172,724.528137 
  C346.136932,728.460205 347.619171,729.796570 351.524017,729.750244 
  C365.348846,729.586304 379.181641,729.892883 393.001160,729.575134 
  C398.174286,729.456177 399.857056,731.260559 399.414978,736.213318 
  C399.075684,740.014709 399.154114,743.882446 399.395630,747.698608 
  C399.647705,751.681946 397.853485,753.012451 394.116455,752.992859 
  C381.123383,752.924683 368.129456,752.956543 355.136139,753.016907 
  C346.382385,753.057556 346.383057,753.107605 346.391052,761.627747 
  C346.394958,765.792419 346.651154,769.976807 346.331146,774.116516 
  C345.980804,778.649231 347.895691,779.763733 352.141754,779.710205 
  C367.965088,779.510620 383.795959,779.823730 399.616364,779.531860 
  C404.805023,779.436096 406.441010,781.414368 406.144409,786.222412 
  C405.919220,789.872986 405.993103,793.554382 406.147797,797.212952 
  C406.332245,801.573792 404.755005,803.423889 400.052704,803.387451 
  C375.898865,803.200012 351.742188,803.209595 327.588104,803.378906 
  C323.089172,803.410400 321.435852,802.081665 321.490662,797.426575 
  C321.688568,780.616821 321.380676,763.801331 321.546967,746.990784 
  C321.749451,726.518372 320.676178,706.052917 321.448822,685.572571 
  C321.621307,681.000366 322.976746,679.569519 327.523010,679.611145 
  C348.511292,679.803528 369.502411,679.693054 390.990112,679.690063 
  z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
  M797.584290,804.895813 
  C766.381470,801.037537 753.755493,777.473389 753.669006,753.424561 
  C753.588135,730.940491 753.756775,708.455017 753.567261,685.972229 
  C753.527954,681.319153 754.758667,679.233398 759.716736,679.612305 
  C764.353271,679.966614 769.053162,679.926025 773.696838,679.623535 
  C778.071045,679.338623 779.464111,680.924255 779.431091,685.320496 
  C779.253418,708.969360 779.303223,732.620483 779.370667,756.270508 
  C779.405457,768.493530 785.685547,777.551208 796.715454,780.024292 
  C811.764832,783.398682 824.222168,777.342957 828.131470,764.395508 
  C829.207520,760.831604 828.838318,757.121948 828.845642,753.476135 
  C828.888672,731.991272 828.860596,710.506226 828.851257,689.021240 
  C828.846619,678.445190 828.637451,679.758179 838.456482,679.690247 
  C842.286926,679.663757 846.123779,679.831116 849.946594,679.660217 
  C853.275635,679.511353 854.961304,680.742920 854.925171,684.190796 
  C854.646545,710.826538 856.114685,737.505493 854.119324,764.088806 
  C852.605835,784.251831 835.993286,800.779907 815.409241,804.349243 
  C809.625916,805.352112 803.848267,805.635315 797.584290,804.895813 
  z"
      />
    </svg>
  );
}
